import React from 'react';
import { Box, SxProps, Theme, Link as MuiLink } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';
import ReactMarkdown, { Components } from 'react-markdown';
import remarkGfm from 'remark-gfm';

const markdownElementSx: SxProps<Theme> = {
  '& table': { borderCollapse: 'collapse', width: '100%' },
  '& th, & td': { border: '1px solid', borderColor: 'divider', p: 1, textAlign: 'left' },
  '& pre': { bgcolor: 'action.hover', p: 1.5, borderRadius: 1, overflow: 'auto' },
  '& code': { fontFamily: 'monospace' },
  '& img': { maxWidth: '100%' },
  '& blockquote': { borderLeft: '4px solid', borderColor: 'divider', ml: 0, pl: 2, color: 'text.secondary' },
};

/** Site-internal links ("/text-editor") navigate in-app; everything else opens in a new tab. */
const components: Components = {
  a: ({ href = '', children }) =>
    href.startsWith('/') && !href.startsWith('//') ? (
      <MuiLink component={RouterLink} to={href}>{children}</MuiLink>
    ) : (
      <MuiLink href={href} target="_blank" rel="noopener noreferrer">{children}</MuiLink>
    ),
};

interface MarkdownContentProps {
  content: string;
  sx?: SxProps<Theme>;
}

const MarkdownContent: React.FC<MarkdownContentProps> = ({ content, sx }) => (
  <Box sx={{ ...markdownElementSx, ...sx }}>
    <ReactMarkdown remarkPlugins={[remarkGfm]} components={components}>{content}</ReactMarkdown>
  </Box>
);

export default MarkdownContent;
